import React from 'react';
import classNames from 'classnames';
import PdfNoEmbedBase from './pdf_no_embed_base.jsx';

const PdfNoEmbedMobile = (props)=>
  <PdfNoEmbedBase {...props} 
    className={classNames('pdf-section-mobile-wrapper grid-mobile-viewer')} 
  />;

export default PdfNoEmbedMobile;